var React = require('react');

function FeaturesIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.573 2.036c.45-1.381 2.405-1.381 2.854 0l1.994 6.138h6.453c1.453 0 2.057 1.86.882 2.713l-5.221 3.793 1.994 6.138c.449 1.382-1.133 2.53-2.308 1.677L12 18.702l-5.22 3.793c-1.176.854-2.758-.295-2.309-1.677l1.994-6.138-5.22-3.793c-1.176-.854-.572-2.713.881-2.713H8.58l1.994-6.138zM12 4.118l-1.63 5.02a1.5 1.5 0 0 1-1.427 1.036H3.665l4.27 3.102a1.5 1.5 0 0 1 .545 1.677l-1.631 5.02 4.27-3.103a1.5 1.5 0 0 1 1.763 0l4.27 3.102-1.632-5.02a1.5 1.5 0 0 1 .545-1.676l4.27-3.102h-5.278a1.5 1.5 0 0 1-1.426-1.037L12 4.118z","fill":"#fff"}));
}

FeaturesIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = FeaturesIcon;

FeaturesIcon.default = FeaturesIcon;
